import {
  getFileBrowserActivitySnapshot,
  registerFileBrowserActivityPublisher,
  registerFileBrowserReadStartListener,
  registerFileBrowserRequestStartListener,
} from '../../../files/browser/in-flight.js';
import { symbolIndexWorkerClient } from './client-api.js';
import { registerWorkerReadyListener } from './client-state.js';
import { terminateSymbolIndexWorker, resetSymbolIndexWorkerLifecycleForTests } from './lifecycle.js';

export { symbolIndexWorkerClient };
export { terminateSymbolIndexWorker };

registerFileBrowserActivityPublisher((snapshot) => {
  symbolIndexWorkerClient.publishFileBrowserActivity(snapshot);
});

registerFileBrowserRequestStartListener(() => {
  symbolIndexWorkerClient.deferBackground();
});

registerFileBrowserReadStartListener(() => {
  symbolIndexWorkerClient.deferBackground();
});

registerWorkerReadyListener(() => {
  symbolIndexWorkerClient.publishFileBrowserActivity(getFileBrowserActivitySnapshot());
});

export async function resetSymbolIndexWorkerClientForTests(): Promise<void> {
  await terminateSymbolIndexWorker();
  resetSymbolIndexWorkerLifecycleForTests();
}
